/*
 * Module for recent searches control
*/
rs.module("controls/recentsearches", [],

    function () {

        var _jsSelectors;
        var _cssClasses;
        var _updateAjaxUrl;

        var _previouslyInitialized;

        // Initialize recent searches
        function initialize(jsSelectors, cssClasses, updateAjaxUrl) {

            _jsSelectors = jsSelectors;
            _cssClasses = cssClasses;
            _updateAjaxUrl = updateAjaxUrl;

            // initialize() will be called multiple times (once for each recent search control rendered)
            // Because of this we need to keep track of previously initialized controls so that we don't duplicate event binding

            // Get all recent search control containers
            var allContainers = $.js(_jsSelectors.container, { multiple: true });

            // Get the current container(s) to be initialized
            var containers = allContainers.not(_previouslyInitialized);

            // Update previously initialized for the next time initialized is called
            _previouslyInitialized = allContainers;

            // Initialize conatiner(s)
            if (containers.length > 0) {

                // show hide recent searches menu on hover with intent
                containers.hoverIntent({
                    handlerOver: function (event) {
                        $(event.currentTarget).js(_jsSelectors.menu).toggleClass(_cssClasses.visible, true);
                    },
                    handlerOut: function (event) {
                        $(event.currentTarget).js(_jsSelectors.menu).toggleClass(_cssClasses.visible, false);
                    },
                    hoverOutDelay: 400
                });

                // Get the menu for each container (there is only one menu per container, but we need "multiple:true" since we are getting them all at once)
                var menus = containers.js(_jsSelectors.menu, { multiple: true });

                // Add class to the last pinned item in each section to show the divider between pinned/unpinned
                // We need to use js to add this class as oppossed to using the :last-child css selector because the pinned and unpinned items are all siblings.
                // This, in conjunction with how :last-child works, means doing "._pinned:last-child" won't work the way we want it to
                menus.js(_jsSelectors.section, { multiple: true, required: false }).each(function () {

                    // for each section get the last pinned item and add class to show divider
                    $(this).js(_jsSelectors.recentSearch, { multiple: true, required: false }).filter(`.${_cssClasses.pinned}`).last().toggleClass(_cssClasses.last, true);
                });

                // Close the menu once a name link is clicked 
                menus.js(_jsSelectors.nameLink, { multiple: true, required: false }).click(function () {
                    $(this).closest(`[data-js=${_jsSelectors.menu}]`).removeClass(_cssClasses.visible);
                });

                // Pin/unpin the recent search when a pin link is clicked
                menus.js(_jsSelectors.pinLink, { multiple: true, required: false }).click(_updateRecentSearch);
            }

            var onRecentSearchLinkClickCallback;

            $.js(jsSelectors.containerInstance).js(jsSelectors.nameLink, { multiple: true, required: false }).click(function () {

                // if callback was provided execute click callback 
                if (onRecentSearchLinkClickCallback) {

                    return onRecentSearchLinkClickCallback.call(this, {
                        employerkey: $(this).data("ek"),
                        accountpartykey: $(this).data("apk"),
                        name: $(this).data("name"),
                        tin: $(this).data("tin"),
                        tincipher: $(this).data("tincipher")
                    });
                }
            });

            //
            // API function to allow consumers to provide a call back function to execute when a recent search link is clicked
            //
            function onRecentSearchLinkClick(onRecentSearchLinkClick) {
                onRecentSearchLinkClickCallback = onRecentSearchLinkClick;
            }

            // Exported instance API
            return {
                onRecentSearchLinkClick
            };
        }

        //
        // Pin or un pin a recent search
        //
        function _updateRecentSearch() {

            var searchHistoryKey = $(this).data("searchhistorykey");
            var isPinning = $(this).closest(`[data-js=${_jsSelectors.recentSearch}]`).hasClass(_cssClasses.unpinned);

            $.post(_updateAjaxUrl, {

                "ownerKey": $(this).data("ownerkey"),
                "ownerKeyType": $(this).data("ownerkeytype"),
                "searchHistoryKey": searchHistoryKey,
                "pin": isPinning

            });

            // Update menu to reflect change (We are not waiting on the post to return so the the UI is quick and responsive)
            if (isPinning) {
                _moveToPinned(searchHistoryKey);
            }
            else {
                _removeFromPinned(searchHistoryKey);
            }
        }

        //
        // Move the recent search to the pinned section in each recent search control (could be multiple)
        //
        function _moveToPinned(searchHistoryKey) {

            // Get the recent searches to be pinned by key (could be more than one if there are multiple recent search controls)
            var recentSearchesToPin = $.js(_jsSelectors.container, { multiple: true, required: true })
                                        .js(_jsSelectors.pinLink, { multiple: true, required: false })
                                        .filter(`[data-searchhistorykey=${searchHistoryKey }]`)
                                        .closest(`[data-js=${_jsSelectors.recentSearch}]`);

            // Loop on searches to pin them
            recentSearchesToPin.each(function () {

                // Get the last pinned item in the section
                var lastPinnedItem = $(this).siblings(`.${_cssClasses.pinned}`).last();

                // If one exists, append the newly pinned item below the last pinned item
                if (lastPinnedItem.length > 0) {
                    lastPinnedItem.after($(this));
                }
                else {
                    // If there are no pinned items prepend it as the only item in the container
                    $(this).closest(`[data-js=${_jsSelectors.sectionSearchesContainer}]`).prepend($(this));
                }

                // Move the "_last" class from the previous last item to our new pinned item since its been appended to the bottom of the list
                lastPinnedItem.removeClass(_cssClasses.last);
                $(this).addClass(_cssClasses.last);

                // Switch the class on the item to pinned
                $(this).removeClass(_cssClasses.unpinned);
                $(this).addClass(_cssClasses.pinned);
            });
        }

        //
        // Remove the recent search from the pinned section in each recent search control (could be multiple)
        //
        function _removeFromPinned(searchHistoryKey) {

            // Get the recent searches to be removed by key (could be more than one if there are multiple recent search controls)
            var recentSearchesToRemove = $.js(_jsSelectors.container, { multiple: true, required: true })
                                            .js(_jsSelectors.pinLink, { multiple: true, required: false })
                                            .filter(`[data-searchhistorykey=${searchHistoryKey}]`)
                                            .closest(`[data-js=${_jsSelectors.recentSearch}]`);

            // Loop on searches to remove them
            recentSearchesToRemove.each(function () {

                // If the item being unpinned is the last one, add the "_last" class to the previous item to show the divider
                if ($(this).hasClass(_cssClasses.last)) {
                    $(this).prev().addClass(_cssClasses.last);
                }

                // If there are no other recent searches in this section, hide the section
                if ($(this).siblings().length === 0) {
                    $(this).closest(`[data-js=${_jsSelectors.section}]`).hide();
                }

                var menu = $(this).closest(`[data-js=${_jsSelectors.menu}]`);

                // Get all other recent searches in the menu
                var otherRecents = menu.js(_jsSelectors.recentSearch, { multiple: true, required: false }).not($(this));

                // If there are no other recent searches period, show empty message
                if (otherRecents.length === 0) {
                    menu.js(_jsSelectors.empty).addClass(_cssClasses.visible);
                }

            });

            // Remove each recent search from its respective pinned list
            recentSearchesToRemove.remove();
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);